import { render, staticRenderFns } from "./LabelInput.vue?vue&type=template&id=d8141490&scoped=true&lang=pug&"
import script from "./LabelInput.vue?vue&type=script&lang=coffee&"
export * from "./LabelInput.vue?vue&type=script&lang=coffee&"
import style0 from "./LabelInput.vue?vue&type=style&index=0&id=d8141490&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8141490",
  null
  
)

export default component.exports